import {GENERIC_SETTING_TYPE_CURRENCY, GENERIC_SETTINGS} from "../pages/generic/Constants";
import {genericGetAll} from "../pages/generic/crud";

// Currency symbols based on the setting value ID from OtherSettings
const currencySymbols = {
    1: '$', // USD
    2: '€', // EUR
    3: '₹', // INR
    4: '£', // GBP
    5: '¥', // JPY
    6: '₽', // RUB
    7: '¥', // CNY
    8: '₣', // CHF
    9: '$', // CAD
    10: '$', // AUD
    // Default is $
    default: '$'
};

// Fetch the current currency setting
export const fetchCurrencySetting = async () => {
    try {
        const response = await genericGetAll(GENERIC_SETTINGS, {});
        const settings = response.data.entities || response.data.payload || [];
        const currencySetting = settings.find(setting => setting.settingType === GENERIC_SETTING_TYPE_CURRENCY);
        
        if (currencySetting) {
            return {
                id: currencySetting.settingValue,
                symbol: currencySymbols[currencySetting.settingValue] || currencySymbols.default
            };
        } else {
            return {
                id: null,
                symbol: currencySymbols.default
            };
        }
    } catch (error) {
        console.error("Error fetching currency setting:", error);
        return {
            id: null,
            symbol: currencySymbols.default
        };
    }
};

// Format amount with currency symbol
export const formatCurrency = (amount, currencySymbol = currencySymbols.default) => {
    if (amount === undefined || amount === null) return `${currencySymbol}0.00`;
    
    return `${currencySymbol}${parseFloat(amount).toFixed(2)}`;
};

// Format amount with currency symbol without decimals
export const formatCurrencyWithoutDecimals = (amount, currencySymbol = currencySymbols.default) => {
    if (amount === undefined || amount === null) return `${currencySymbol}0`;
    
    return `${currencySymbol}${Math.round(parseFloat(amount))}`;
};

// Get currency symbol by id
export const getCurrencySymbol = (id) => {
    return currencySymbols[id] || currencySymbols.default;
};

// Compute the round-off amount to add to `totalAfterTax` given the ROUND_OFF_MODE.
// CEILING: always round up to next whole number (e.g., 33.33 -> 34.00, round-off = 0.67)
// NEAREST: standard half-up rounding (e.g., 33.33 -> 33.00 round-off = -0.33; 33.77 -> 34.00 round-off = 0.23)
export const computeRoundOffAmount = (totalAfterTax, mode = 'CEILING') => {
    const total = parseFloat(totalAfterTax);
    if (!isFinite(total)) return 0;
    const target = mode === 'NEAREST' ? Math.round(total) : Math.ceil(total);
    return parseFloat((target - total).toFixed(2));
};
